import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import FileDetails from "./FileDetails";
import FileUploadButton from "./FileUploadButton";
import FileUploadFailedFiles from "./FileUploadFailedFiles";
import { DragAndDropRow, DragAndDropText, ItemsCol } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var FileUploadWithDropzone = function FileUploadWithDropzone(_ref) {
  var buttonRef = _ref.buttonRef,
      cancelButtonText = _ref.cancelButtonText,
      cancelUploadButtonTitle = _ref.cancelUploadButtonTitle,
      deleteFileButtonTitle = _ref.deleteFileButtonTitle,
      disabled = _ref.disabled,
      dragAndDropText = _ref.dragAndDropText,
      errorText = _ref.errorText,
      getRootProps = _ref.getRootProps,
      failedFiles = _ref.failedFiles,
      files = _ref.files,
      getUploadProgressAriaLabel = _ref.getUploadProgressAriaLabel,
      getUploadProgressSummary = _ref.getUploadProgressSummary,
      handleFocus = _ref.handleFocus,
      id = _ref.id,
      isMulti = _ref.isMulti,
      isInCardLayout = _ref.isInCardLayout,
      maxFiles = _ref.maxFiles,
      onFileAttached = _ref.onFileAttached,
      open = _ref.open,
      rejectedFilesLength = _ref.rejectedFilesLength,
      removeFileButtonsRefMap = _ref.removeFileButtonsRefMap,
      renderFileDetailsIcon = _ref.renderFileDetailsIcon,
      renderFileDetailsLabel = _ref.renderFileDetailsLabel,
      renderRejectedErrorText = _ref.renderRejectedErrorText,
      requests = _ref.requests,
      retryButtonText = _ref.retryButtonText,
      setFailedFiles = _ref.setFailedFiles,
      setFiles = _ref.setFiles,
      setRequests = _ref.setRequests,
      showDropZone = _ref.showDropZone,
      showFileDetails = _ref.showFileDetails,
      uploadButtonAriaDescribedby = _ref.uploadButtonAriaDescribedby,
      uploadButtonSize = _ref.uploadButtonSize,
      uploadButtonTitle = _ref.uploadButtonTitle,
      uploadButtonVariant = _ref.uploadButtonVariant,
      uploadIconTitle = _ref.uploadIconTitle,
      uploadHandler = _ref.uploadHandler,
      uploadProgressAriaLive = _ref.uploadProgressAriaLive;
  var hasErrors = failedFiles.length > 0 || rejectedFilesLength > 0;
  var hasFiles = files.length > 0;
  var buttonProps = {
    disabled: disabled,
    id: id,
    isMulti: isMulti,
    open: open,
    showDropZone: showDropZone,
    uploadButtonAriaDescribedby: uploadButtonAriaDescribedby,
    uploadButtonSize: uploadButtonSize,
    uploadButtonTitle: uploadButtonTitle,
    uploadButtonVariant: uploadButtonVariant,
    uploadIconTitle: uploadIconTitle
  };
  var fileDetailsProps = {
    cancelUploadButtonTitle: cancelUploadButtonTitle,
    deleteFileButtonTitle: deleteFileButtonTitle,
    files: files,
    getUploadProgressAriaLabel: getUploadProgressAriaLabel,
    getUploadProgressSummary: getUploadProgressSummary,
    handleFocus: handleFocus,
    isInCardLayout: isInCardLayout,
    onFileAttached: onFileAttached,
    removeFileButtonsRefMap: removeFileButtonsRefMap,
    renderFileDetailsIcon: renderFileDetailsIcon,
    renderFileDetailsLabel: renderFileDetailsLabel,
    requests: requests,
    setFiles: setFiles,
    uploadProgressAriaLive: uploadProgressAriaLive
  };
  var failedFilesProps = {
    cancelButtonText: cancelButtonText,
    errorText: errorText,
    failedFiles: failedFiles,
    files: files,
    maxFiles: maxFiles,
    onFileAttached: onFileAttached,
    rejectedFilesLength: rejectedFilesLength,
    renderRejectedErrorText: renderRejectedErrorText,
    retryButtonText: retryButtonText,
    setFailedFiles: setFailedFiles,
    setFiles: setFiles,
    setRequests: setRequests,
    uploadHandler: uploadHandler
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(DragAndDropRow, _extends({
    disabled: disabled
  }, getRootProps()), ___EmotionJSX(FileUploadButton, _extends({}, buttonProps, {
    ref: buttonRef
  })), ___EmotionJSX(DragAndDropText, {
    disabled: disabled,
    shouldUseFixedFontStyle: true
  }, dragAndDropText)), showFileDetails && hasFiles && ___EmotionJSX(ItemsCol, null, files.map(function (file, index) {
    return ___EmotionJSX(FileDetails, _extends({}, fileDetailsProps, {
      file: file,
      index: index,
      key: "".concat(file.name).concat(file.size)
    }));
  })), hasErrors && ___EmotionJSX(FileUploadFailedFiles, failedFilesProps));
};

FileUploadWithDropzone.displayName = 'FileUploadWithDropzone';
export default FileUploadWithDropzone;